
<span #reactComponentPlaceholder class='o-wrapPage wrapperReporting'>
</span>

<!-- <ng-container *ngIf='(isLoading)'>
    <spinner></spinner>
</ng-container> -->